import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-avatarUpload",
  "use": "icon-avatarUpload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-avatarUpload\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024.089722 707.047619a219.428571 219.428571 0 0 1-219.428572 219.428571H486.95296L487.70877 902.095238V506.075429l-137.923048 137.923047L315.311055 609.52381l162.304-162.304L512.089722 412.745143l34.474667 34.474667L708.868389 609.52381l-34.474667 34.474666L536.470674 506.075429V877.714286h268.190476a170.666667 170.666667 0 1 0-17.334857-340.455619A292.571429 292.571429 0 1 0 219.518293 438.857143c0 9.313524 0.536381 18.505143 1.389715 27.574857A206.994286 206.994286 0 0 0 243.899246 877.104762V877.714286h72.387047v48.761904H219.518293v-2.901333A255.683048 255.683048 0 0 1 171.244008 429.104762a341.138286 341.138286 0 1 1 677.619809 62.902857A219.428571 219.428571 0 0 1 1024.089722 707.047619z\" p-id=\"798\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/avatarUpload.svg
// module id = L+Td
// module chunks = 10